var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',{staticClass:"tbdc-fullwidthpage"},[_c('v-col',[_c('h2',[_vm._v("We are sorry, the page you requested cannot be found.")]),_c('p',{staticClass:"grey--text"},[_vm._v("The URL may be misspelled or the page you're looking for is no longer available.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }